import axios from "axios";

export default {
    read: () => axios.get("/api/widgets/read"),
    add: (obj) => axios.post("/api/widgets/add", obj),
    remove: (id) => axios.get(`/api/widgets/remove/${id}`),
    show: (id) => axios.get(`/api/widgets/show/${id}`),
    hide: (id) => axios.get(`/api/widgets/hide/${id}`),
    updatePositions: (obj) => axios.post("/api/widgets/update_positions", obj),
    updateSettings: (obj) => axios.post("/api/widgets/update_settings", obj),
};
